'use strict';

wv.onBoardTutorialResource = undefined;

const store = {
    namespaced: true,

    state: {
        resource: {}
    },

    mutations: {
        SET_RESOURCE(state, resource) {
            wv.onBoardTutorialResource = resource;
            state.resource = JSON.parse(JSON.stringify(wv.onBoardTutorialResource));
        }
    },

    actions: {
        async loadResource({commit}) {
            try {
                const resource = await loadOnBoardTutorialResource();
                commit('SET_RESOURCE', resource);
            } catch (error) {
                console.error('Error loading onBoard Tutorial resource, error: ' + error);
            }
        },

        async setResource({commit}, resource) {
            if (!resource) {
                await this.loadResource();
            }

            commit('SET_RESOURCE', resource);
        }
    }
};

export default function register(rootStore) {
    rootStore.registerModule('onBoardTutorial', store);
}